import { render, staticRenderFns } from "./LearningObjectivesStep.vue?vue&type=template&id=f5915a58&"
import script from "./LearningObjectivesStep.vue?vue&type=script&lang=ts&"
export * from "./LearningObjectivesStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VTextField})
